import { useTranslation } from 'react-i18next';
import { type PromoCodeModuleSpecsFragment } from '../../../../../api/fragments/PromoCodeModuleSpecs';
import {
    CreatePromoCodeModuleDocument,
    type CreatePromoCodeModuleMutation,
    type CreatePromoCodeModuleMutationVariables,
} from '../../../../../api/mutations/createPromoCodeModule';
import { type PromoCodeModuleSettings } from '../../../../../api/types';
import InputField from '../../../../../components/fields/InputField';
import validators from '../../../../../utilities/validators';
import PromoCodeModulePage, { type PromoCodeModulePageProps } from '../../PromoCodeModulePage';
import { type ModuleImplementation } from './types';

const implementation: ModuleImplementation<PromoCodeModuleSpecsFragment, PromoCodeModuleSettings> = {
    PageComponent: ({ module }: PromoCodeModulePageProps) => <PromoCodeModulePage module={module} />,
    getTitle: t => t('moduleDetails:implementations.PromoCodeModule.className'),
    FormComponent: () => {
        const { t } = useTranslation(['moduleDetails']);

        return (
            <InputField
                {...t('moduleDetails:fields.displayName', { returnObjects: true })}
                name="displayName"
                required
            />
        );
    },
    getValidator: () => validators.compose(validators.requiredNonEmptyString('displayName')),
    create: async (apolloClient, companyId, values) =>
        apolloClient
            .mutate<CreatePromoCodeModuleMutation, CreatePromoCodeModuleMutationVariables>({
                mutation: CreatePromoCodeModuleDocument,
                variables: { companyId, settings: values },
            })
            .then(({ data }) => data.module),
};

export default implementation;
